"use strict";
// packages/types/src/ccp.ts
Object.defineProperty(exports, "__esModule", { value: true });
